import type { PropsWithChildren } from 'react';
import React, { useEffect, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { getCurrentUser } from '#/graphql/queries';
import SessionContext, { type SessionContextType } from './SessionContext';
import { CurrentUserData, GetCurrentUserQuery } from '#/graphql/types';
import { stripAuthParams } from '#/common/utils/url';

const getCurrentUserQuery = gql(getCurrentUser);

const SessionProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { data, loading } = useQuery<GetCurrentUserQuery>(getCurrentUserQuery);

  const ctx = useMemo<SessionContextType>(() => {
    const { __typename, ...userData } = data?.getCurrentUser?.data ?? {};
    return {
      ...userData,
      loading,
    };
  }, [data, loading]);

  useEffect(() => {
    stripAuthParams();
  }, []);

  return <SessionContext.Provider value={ctx}>{children}</SessionContext.Provider>;
};

export default React.memo(SessionProvider);
